<div id="btl-design">
    <router-outlet></router-outlet>
</div>
